import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { Dispatch } from 'redux';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './svs.module.css';
import { VatAndPaymentDTO as VatAndPayment } from '../../../../business/models/dto/svs/svs.dto';
import { tabVatAndPaymentFieldChange, setCurrentTabAsDirty, updateSvsIBAN, updateSvsBBAN } from '../../../../store/details/svs/actions';
import { BelfiusCurrencyInput } from '../../../custom/belfius-currency-input';
import { Role } from '../../../../store/shared/model';
import { BusinessValidation, BusinessValidationType } from '../../../../business/models/policy-business.model';
import { BelfiusIban } from 'src/components/custom/belfius-iban-input';

interface PropsFromState {
  readonly data: VatAndPayment;
  readonly locked: boolean;
  readonly validations: BusinessValidation[];
}

interface PropsFromDispatch {
  readonly tabVatAndPaymentFieldChange: typeof tabVatAndPaymentFieldChange;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
  readonly updateSvsIBAN: typeof updateSvsIBAN;
  readonly updateSvsBBAN: typeof updateSvsBBAN;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class VatAndPayments extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  updateIban = (iban: string) => {
    this.props.setCurrentTabAsDirty();
    this.props.tabVatAndPaymentFieldChange({ ...this.props.data, iban: iban});
    this.props.updateSvsIBAN();
  }


  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>{this.localization.get('details.svs.vatAndPayment.info')}</span>
            </div>
          </div>

          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.formatString('details.svs.vatAndPayment.vatToBeJustified', {
                  vatPercentage: '6%'
                })}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.vatAndPayment.vat6ToBeJustifiedAmount.placeholder')}
                value={this.props.data.vat6ToBeJustifiedAmount === '' || this.props.data.vat6ToBeJustifiedAmount === null ? '' : this.props.data.vat6ToBeJustifiedAmount.toString()}
                onChange={(value: string) => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.tabVatAndPaymentFieldChange({ ...this.props.data, vat6ToBeJustifiedAmount: values.value === '' ? '' : +values.value });
                }}
              />
            </div>
          </div>


          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.formatString('details.svs.vatAndPayment.vatToBeJustified', {
                  vatPercentage: '21%'
                })}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.vatAndPayment.vat21ToBeJustifiedAmount.placeholder')}
                value={this.props.data.vat21ToBeJustifiedAmount === '' || this.props.data.vat21ToBeJustifiedAmount === null ? '' : this.props.data.vat21ToBeJustifiedAmount.toString()}
                onChange={(value: string) => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.tabVatAndPaymentFieldChange({ ...this.props.data, vat21ToBeJustifiedAmount: values.value === '' ? '' : +values.value });
                }}
              />
            </div>
          </div>

          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.vatAndPayment.deductibleVatPercentage')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.vatAndPayment.deductibleVatPercentage.placeholder')}
                value={this.props.data.deductibleVatPercentage === '' || this.props.data.deductibleVatPercentage === null ? '' : this.props.data.deductibleVatPercentage.toString()}
                onChange={(value: string) => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.tabVatAndPaymentFieldChange({ ...this.props.data, deductibleVatPercentage: values.value === '' ? '' : +values.value });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.column}>
              <div className={`${styles.item} ${styles.border}`}>
                <span className={styles.text}>{this.localization.get('details.svs.vatAndPayment.payment.info')}</span>
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                {this.props.validations.find(item => item.businessValidationType === BusinessValidationType.ibanSvs && item.hasError === true)
                && this.props.data.iban
                && <div className={styles.notValid} ></div> }
                  <BelfiusIban
                      className={styles.input}
                      locked={this.props.locked}
                      placeholder={this.localization.get('details.person.iban')}
                      value={this.props.data.iban}
                      onUpdateValue={this.updateIban} />
                </div>
              </div>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <input className={styles.input}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.person.bic')}
                    value={this.props.data.bic}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      this.props.setCurrentTabAsDirty();
                      this.props.tabVatAndPaymentFieldChange({ ...this.props.data, bic: event.target.value });
                    }} />
                </div>
              </div>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <input className={styles.input}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.person.bban')}
                    value={this.props.data.financialAccountNumber}
                    autoComplete='off'
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      this.props.setCurrentTabAsDirty();
                      this.props.tabVatAndPaymentFieldChange({ ...this.props.data, financialAccountNumber: event.target.value });
                      this.props.updateSvsBBAN();
                    }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

const mapStateToProps = ({ details: { detailsSvs }, caseState: { selectedCase }, shared: { roles }}: ApplicationState): PropsFromState => ({
  data: {
    deductibleVatPercentage: detailsSvs.vatAndPayment.deductibleVatPercentage,
    financialAccountNumber: detailsSvs.vatAndPayment.financialAccountNumber,
    iban: detailsSvs.vatAndPayment.iban,
    bic: detailsSvs.vatAndPayment.bic,
    vat6ToBeJustifiedAmount: detailsSvs.vatAndPayment.vat6ToBeJustifiedAmount,
    vat21ToBeJustifiedAmount: detailsSvs.vatAndPayment.vat21ToBeJustifiedAmount
  },
  locked: detailsSvs.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
  validations: detailsSvs.validations
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  tabVatAndPaymentFieldChange: (data: VatAndPayment) => dispatch(tabVatAndPaymentFieldChange(data)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty()),
  updateSvsIBAN: () => dispatch(updateSvsIBAN()),
  updateSvsBBAN: () => dispatch(updateSvsBBAN())
});

export default connect(mapStateToProps, mapDispatchToProps)(VatAndPayments);
